/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/User', 'model/UserLocal', 'model/InputValidationFeedback'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/User'), require('../model/UserLocal'), require('../model/InputValidationFeedback'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.User, root.ForStractionServiceApi.UserLocal, root.ForStractionServiceApi.InputValidationFeedback);
  }
}(this, function(ApiClient, User, UserLocal, InputValidationFeedback) {
  'use strict';

  /**
   * User service.
   * @module api/UserApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new UserApi. 
   * @alias module:api/UserApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the userAddPut operation.
     * @callback module:api/UserApi~userAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/User} body 
     * @param {module:api/UserApi~userAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/User/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userAddUserIfEmailNotInUsePut operation.
     * @callback module:api/UserApi~userAddUserIfEmailNotInUsePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addUserIfEmailNotInUse
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserLocal} body 
     * @param {Boolean} skipCheck 
     * @param {Boolean} sendInvitation 
     * @param {module:api/UserApi~userAddUserIfEmailNotInUsePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userAddUserIfEmailNotInUsePut = function(_4SAPIAppID, body, skipCheck, sendInvitation, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'skipCheck' is set
      if (skipCheck == undefined || skipCheck == null) {
        throw "Missing the required parameter 'skipCheck' when calling userAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'sendInvitation' is set
      if (sendInvitation == undefined || sendInvitation == null) {
        throw "Missing the required parameter 'sendInvitation' when calling userAddUserIfEmailNotInUsePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'skipCheck': skipCheck,
        'sendInvitation': sendInvitation
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/User/addUserIfEmailNotInUse', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userCreateUserLoginLinkGet operation.
     * @callback module:api/UserApi~userCreateUserLoginLinkGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createUserLoginLink
     * @param {String} _4SAPIAppID 
     * @param {Integer} receiverUserID 
     * @param {module:api/UserApi~userCreateUserLoginLinkGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.userCreateUserLoginLinkGet = function(_4SAPIAppID, receiverUserID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userCreateUserLoginLinkGet";
      }

      // verify the required parameter 'receiverUserID' is set
      if (receiverUserID == undefined || receiverUserID == null) {
        throw "Missing the required parameter 'receiverUserID' when calling userCreateUserLoginLinkGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'receiverUserID': receiverUserID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/User/createUserLoginLink', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userEditUserIfEmailNotInUsePut operation.
     * @callback module:api/UserApi~userEditUserIfEmailNotInUsePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editUserIfEmailNotInUse
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserLocal} body 
     * @param {module:api/UserApi~userEditUserIfEmailNotInUsePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userEditUserIfEmailNotInUsePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userEditUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userEditUserIfEmailNotInUsePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/User/editUserIfEmailNotInUse', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLoadCurrentUserGet operation.
     * @callback module:api/UserApi~userLoadCurrentUserGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentUser
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserApi~userLoadCurrentUserGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/User}
     */
    this.userLoadCurrentUserGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLoadCurrentUserGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = User;

      return this.apiClient.callApi(
        '/User/loadCurrentUser', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSearchByEmailAndHashedPasswordGet operation.
     * @callback module:api/UserApi~userSearchByEmailAndHashedPasswordGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/User>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchByEmailAndHashedPassword
     * @param {String} _4SAPIAppID 
     * @param {String} email 
     * @param {String} password 
     * @param {module:api/UserApi~userSearchByEmailAndHashedPasswordGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/User>}
     */
    this.userSearchByEmailAndHashedPasswordGet = function(_4SAPIAppID, email, password, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSearchByEmailAndHashedPasswordGet";
      }

      // verify the required parameter 'email' is set
      if (email == undefined || email == null) {
        throw "Missing the required parameter 'email' when calling userSearchByEmailAndHashedPasswordGet";
      }

      // verify the required parameter 'password' is set
      if (password == undefined || password == null) {
        throw "Missing the required parameter 'password' when calling userSearchByEmailAndHashedPasswordGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'email': email,
        'password': password
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [User];

      return this.apiClient.callApi(
        '/User/searchByEmailAndHashedPassword', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSearchUsersWithoutBossGet operation.
     * @callback module:api/UserApi~userSearchUsersWithoutBossGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/User>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchUsersWithoutBoss
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserApi~userSearchUsersWithoutBossGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/User>}
     */
    this.userSearchUsersWithoutBossGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSearchUsersWithoutBossGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [User];

      return this.apiClient.callApi(
        '/User/searchUsersWithoutBoss', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSendForgotPasswordGet operation.
     * @callback module:api/UserApi~userSendForgotPasswordGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendForgotPassword
     * @param {String} _4SAPIAppID 
     * @param {String} userEmail 
     * @param {module:api/UserApi~userSendForgotPasswordGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.userSendForgotPasswordGet = function(_4SAPIAppID, userEmail, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSendForgotPasswordGet";
      }

      // verify the required parameter 'userEmail' is set
      if (userEmail == undefined || userEmail == null) {
        throw "Missing the required parameter 'userEmail' when calling userSendForgotPasswordGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'userEmail': userEmail
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/User/sendForgotPassword', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSendMobileAppLinkWithSmsGet operation.
     * @callback module:api/UserApi~userSendMobileAppLinkWithSmsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendMobileAppLinkWithSms
     * @param {String} _4SAPIAppID 
     * @param {String} phoneNumber 
     * @param {module:api/UserApi~userSendMobileAppLinkWithSmsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userSendMobileAppLinkWithSmsGet = function(_4SAPIAppID, phoneNumber, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSendMobileAppLinkWithSmsGet";
      }

      // verify the required parameter 'phoneNumber' is set
      if (phoneNumber == undefined || phoneNumber == null) {
        throw "Missing the required parameter 'phoneNumber' when calling userSendMobileAppLinkWithSmsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'phoneNumber': phoneNumber
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/User/sendMobileAppLinkWithSms', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSendUserInvitationGet operation.
     * @callback module:api/UserApi~userSendUserInvitationGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendUserInvitation
     * @param {String} _4SAPIAppID 
     * @param {Integer} receiverUserID 
     * @param {module:api/UserApi~userSendUserInvitationGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userSendUserInvitationGet = function(_4SAPIAppID, receiverUserID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSendUserInvitationGet";
      }

      // verify the required parameter 'receiverUserID' is set
      if (receiverUserID == undefined || receiverUserID == null) {
        throw "Missing the required parameter 'receiverUserID' when calling userSendUserInvitationGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'receiverUserID': receiverUserID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/User/sendUserInvitation', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSetCurrentCompanyAsDefaultLoginCompanyGet operation.
     * @callback module:api/UserApi~userSetCurrentCompanyAsDefaultLoginCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setCurrentCompanyAsDefaultLoginCompany
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserApi~userSetCurrentCompanyAsDefaultLoginCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userSetCurrentCompanyAsDefaultLoginCompanyGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSetCurrentCompanyAsDefaultLoginCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/User/setCurrentCompanyAsDefaultLoginCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userSetFirstPasswordGet operation.
     * @callback module:api/UserApi~userSetFirstPasswordGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setFirstPassword
     * @param {String} _4SAPIAppID 
     * @param {String} newPassword 
     * @param {module:api/UserApi~userSetFirstPasswordGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userSetFirstPasswordGet = function(_4SAPIAppID, newPassword, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userSetFirstPasswordGet";
      }

      // verify the required parameter 'newPassword' is set
      if (newPassword == undefined || newPassword == null) {
        throw "Missing the required parameter 'newPassword' when calling userSetFirstPasswordGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'newPassword': newPassword
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/User/setFirstPassword', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userValidatePasswordGet operation.
     * @callback module:api/UserApi~userValidatePasswordGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InputValidationFeedback>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * validatePassword
     * @param {String} _4SAPIAppID 
     * @param {String} password 
     * @param {module:api/UserApi~userValidatePasswordGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InputValidationFeedback>}
     */
    this.userValidatePasswordGet = function(_4SAPIAppID, password, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userValidatePasswordGet";
      }

      // verify the required parameter 'password' is set
      if (password == undefined || password == null) {
        throw "Missing the required parameter 'password' when calling userValidatePasswordGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'password': password
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InputValidationFeedback];

      return this.apiClient.callApi(
        '/User/validatePassword', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
